import {format, subDays} from "date-fns"

export type TReachPeriod = "7d" | "30d" | "lifetime"

export const REACH_PERIODS: readonly TReachPeriod[] = ["7d", "30d", "lifetime"]

export const DEFAULT_REACH_PERIOD: TReachPeriod = "30d"

const PERIOD_DAYS: Record<Exclude<TReachPeriod, "lifetime">, number> = {
  "7d": 7,
  "30d": 30,
}

export function parseReachPeriod(raw: string | null): TReachPeriod {
  return REACH_PERIODS.includes(raw as TReachPeriod) ? (raw as TReachPeriod) : DEFAULT_REACH_PERIOD
}

/**
 * Map a period to the `{from, to}` window (YYYY-MM-DD, inclusive) sent to the
 * Reach Engine endpoints. Windows roll back from today; "lifetime" omits both
 * bounds so the API returns all-time statistics.
 */
export function getPeriodRange(period: TReachPeriod, today: Date = new Date()): {from?: string; to?: string} {
  if (period === "lifetime") {
    return {}
  }
  return {
    from: format(subDays(today, PERIOD_DAYS[period] - 1), "yyyy-MM-dd"),
    to: format(today, "yyyy-MM-dd"),
  }
}
